export function toTitleCaseFromKebabCase(str) {
    str = str.replace('-',' ').toLowerCase();
    return str.replace(/\b\S/g, function (txt) {
        return txt.charAt(0).toUpperCase();
    });
}